import { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import callAPI from '../../../../helpers/callAPI'
import useCallApi from '../../../../hooks/useCallApi'

const BlacklistModal = ({ isOpen, setIsOpen, showSystemMessage, defaultType, refetch, usedCountries, isEdit }) => {

    const { dataLoaded: countryListDataLoaded, data: countryListData } = useCallApi(`countryList`, 'GET', {}, [])
    const [type, setType] = useState('email')
    const [value, setValue] = useState('')
    const [notes, setNotes] = useState('')
    const [country, setCountry] = useState('')
    const [status, setStatus] = useState('')

    useEffect(() => {
        if (isEdit) {
            setType('country')
            setStatus(isEdit.status)
        } else {
            setType(defaultType)
        }
    }, [defaultType])

    const createBlacklist = async (e) => {
        e.preventDefault()
        let result
        if (type === 'country') {
            result = await callAPI('compliance/blacklist/countries', 'POST', { country: { code: country, name: countryListData.countries.find(c => c.country_code === country).country_name }, status: status })
        } else {
            result = await callAPI('compliance/blacklist', 'POST', { type, value: value, notes: notes })

        }
        if (result.success) {
            showSystemMessage('success', 'Blacklist created successfully')
            setIsOpen(false)
            refetch()
        } else {
            showSystemMessage('error', result.errors.message)
        }
    }

    const editBlacklist = async (e) => {
        e.preventDefault()
        let result
        result = await callAPI(`compliance/blacklist/country/${isEdit.country_code}/${status}`, 'PUT')
        if (result.success) {
            showSystemMessage('success', 'Blacklist updated successfully')
            setIsOpen(false)
            refetch()
        } else {
            showSystemMessage('error', result.errors.message)
        }
    }



    if (type !== 'country') {
        return (
            <Modal show={isOpen} onHide={() => setIsOpen(false)}>
                <form onSubmit={createBlacklist}>
                    <Modal.Header closeButton>Create Blacklist</Modal.Header>
                    <Modal.Body>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>Keyword: </span>
                            <div className="w-75">
                                <Form.Control as="select" value={type} onChange={(e) => setType(e.target.value)}>
                                    <option value="email">Email</option>
                                    <option value="ip">IP</option>
                                    <option value="redirect">Redirect Affiliate ID</option>
                                    <option value="country">Country</option>
                                </Form.Control>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>Blacklisted Value: </span>
                            <div className="w-75">
                                <Form.Control type="text" value={value} onChange={(e) => setValue(e.target.value)} required />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                            <span>Notes: </span>
                            <div className="w-75">
                                <Form.Control type="text" value={notes} onChange={(e) => setNotes(e.target.value)} required />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" type="submit">
                            Create
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        )
    } else {
        if (!isEdit) {
            return (
                <Modal show={isOpen} onHide={() => setIsOpen(false)}>
                    <form onSubmit={createBlacklist}>
                        <Modal.Header closeButton>Create Blacklist</Modal.Header>
                        <Modal.Body>
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>Keyword: </span>
                                <div className="w-75">
                                    <Form.Control as="select" value={type} onChange={(e) => setType(e.target.value)}>
                                        <option value="email">Email</option>
                                        <option value="ip">IP</option>
                                        <option value="redirect">Redirect Affiliate ID</option>
                                        <option value="country">Country</option>
                                    </Form.Control>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>Country: </span>
                                <div className="w-75">
                                    <Form.Control as="select" value={country} onChange={(e) => setCountry(e.target.value)} required>
                                        <option value="">Select a country</option>
                                        {countryListDataLoaded
                                            ? countryListData.countries.filter(c => !usedCountries.includes(c.country_code))
                                                .map((country, index) => (
                                                    <option key={index} value={country.country_code}>
                                                        {country.country_name}
                                                    </option>
                                                ))
                                            : null}
                                    </Form.Control>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>Status: </span>
                                <div className="w-75">
                                    <Form.Control as="select" value={status} onChange={(e) => setStatus(e.target.value)} required>
                                        <option value="">Select a status</option>
                                        <option value="TOTAL">Total</option>
                                        <option value="PARTIAL">Partial</option>
                                    </Form.Control>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" type="submit">
                                Create
                            </Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            )
        } else {
            return (
                <Modal show={isOpen} onHide={() => setIsOpen(false)}>
                    <form onSubmit={editBlacklist}>
                        <Modal.Header closeButton>Edit Blacklist</Modal.Header>
                        <Modal.Body>
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>Keyword: </span>
                                <div className="w-75">
                                    Country
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>Country: </span>
                                <div className="w-75">
                                    {isEdit.country} - {isEdit.country_code}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                <span>Notes: </span>
                                <div className="w-75">
                                    <Form.Control as="select" value={status} onChange={(e) => setStatus(e.target.value)} required>
                                        <option value="">Select a status</option>
                                        <option value="TOTAL">Total</option>
                                        <option value="PARTIAL">Partial</option>
                                    </Form.Control>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="warning" type="submit">
                                Update
                            </Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            )
        }
      
        
        }
    }

    export default BlacklistModal
